import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { verifyOtpAndCreatePartner } from "../../Actions/signupAction";
import LoadingSpinner from "../CommonComponents/loadingSpinner";

const PhoneVerification = ({setFormdata,formdata,handleNext,handleBack,}) => {
  const otpInfo = useSelector(state => state.otp);
  const dispatch = useDispatch();

  const codeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getOtpMessage = () => {
    const medium = otpInfo.medium;
    if (medium === 'WHATSAPP') {
      return 'A 6 digit verification code has been sent to your WhatsApp';
    } else if (medium === 'SMS') {
      return 'A 6 digit verification code has been sent via SMS to your phone number';
    } else {
      return 'A 6 digit verification code has been sent to your phone number';
    }
  };


  const handleSubmit = (ev) => {
    ev.preventDefault();

    setLoading(true);
    dispatch(verifyOtpAndCreatePartner(formdata, codeRef.current.value));
  };

  useEffect(() => {
    if (loading && otpInfo.verified) {
      handleNext();
      return;
    }

    if (otpInfo.verifError) {
      handleBack();
      return;
    }

    if (loading && otpInfo.verified !== null && !otpInfo.verified) {
      setLoading(false);
      setError("Wrong code");
    }
  }, [otpInfo, loading])

  useEffect(() => {
      if (error) {
          let timer = setTimeout(() => setError(null), 4 * 1000);
          return () => clearTimeout(timer);
      }
  }, [error]);

  return (
    <form className="d-flex flex-column sd-form sd-form--verif-code" onSubmit={handleSubmit}>
      <div className="login-title">Verify your phone number</div>
      <div className="d-flex flex-column">
        <label className="sd-label sd-label--verif-code">{getOtpMessage()}</label>
        <input
          ref={codeRef}
          type="text"
          required={true}
          className="sd-input sd-input--verif-code"
        />
        <div className="sd-label sd-label--verif-code">{otpInfo.attemptsLeft} attempt(s) left</div>
      </div>
      
      <div>
      { 
            error && <div className="alert alert-danger fw-bold">
                {error}
            </div>
      }
      <div className="d-flex justify-content-center text-center gap-8">
        <div
          className="login-btn login-secondary-btn w-100"
          onClick={handleBack}
        >
          Cancel
        </div>
        <input
          type="submit"
          className="login-btn login-primary-btn w-100"
          value="Verify"
        ></input>
      </div>
      </div>
      
      {loading && <LoadingSpinner target={"sd-form"} />}
    </form>
  );
};
export default PhoneVerification;
